module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "resetPage",
    attrs: {
      "md-open-from": "#resetPage",
      "md-close-to": "#resetPage"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "14px",
      "padding-bottom": "0px"
    }
  }, [_c('md-dialog-content', [_c('p', [_vm._v(_vm._s(_vm.displayPopupTitle))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.addResetOption == 'custom' || _vm.toolbarManuTypeName == 'adjustSelectedPages') ? _c('md-input-container', [_c('label', {
    attrs: {
      "for": "enter-starting-number"
    }
  }, [_vm._v("Enter Starting Number")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    on: {
      "input": _vm.addValidateNumber
    },
    model: {
      value: (_vm.startingNumber),
      callback: function($$v) {
        _vm.startingNumber = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "startingNumber"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.toolbarManuTypeName == 'resetAllPages') ? _c('div', {
    staticClass: "from-to"
  }, [_c('md-radio', {
    attrs: {
      "mdValue": "default"
    },
    model: {
      value: (_vm.addResetOption),
      callback: function($$v) {
        _vm.addResetOption = $$v
      },
      expression: "addResetOption"
    }
  }, [_vm._v("Default (1)")]), _vm._v(" "), _c('md-radio', {
    attrs: {
      "mdValue": "custom"
    },
    model: {
      value: (_vm.addResetOption),
      callback: function($$v) {
        _vm.addResetOption = $$v
      },
      expression: "addResetOption"
    }
  }, [_vm._v("Custom")])], 1) : _vm._e(), _vm._v(" "), (_vm.addErrorFromMessage) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addErrorFromMessage))]) : _vm._e(), _vm._v(" "), (!_vm.btnDisabled) ? _c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": _vm.updateResetPages
    }
  }, [_vm._v(_vm._s(_vm.displayPopupButtonTitle))]) : _c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "disabled": _vm.btnDisabled
    }
  }, [_vm._v(_vm._s(_vm.displayPopupButtonTitle))])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b81e76cc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/reset-page.vue
// module id = 1283
// module chunks = 21